import * as React from 'react';
export const IcSpotcolor = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M5.5 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM12 19a1 1 0 100 2 1 1 0 000-2zm5-11a1 1 0 100-2 1 1 0 000 2zm1 1a3 3 0 00-2.5 1.34L14 10a4 4 0 10-6.79 2.89l-.68 1.19A3.07 3.07 0 006 14a3 3 0 103 3 3 3 0 00-.74-1.95L9 13.84c.324.099.66.153 1 .16a4 4 0 003.5-2.09l1.53.38A3 3 0 1018 9z'
      fill='currentColor'
    />
  </svg>
);
